'use strict';

var Log = require('utils/log');
var Cookie = require('utils/cookie');
var Requests = require('utils/requests');

var I18N = {
    language: '',
    defaultLanguage: 'en',

    strings: {},
    dataPoints: {},

    supportedLanguages: undefined,
};

I18N.initialize = function () {
    var language = Cookie.get('language', navigator.language || navigator.userLanguage);
    language = language.substring(0, 2);

    return this.setLanguage(language);
};

I18N.TR = function (input) {
    var defaultTranslation = input;

    if ('TC_DEBUG' in window && TC_DEBUG && I18N.language != 'de') {
        defaultTranslation = '!! ' + defaultTranslation;
    }

    return I18N.strings[input] || defaultTranslation;
};

I18N.DATAPOINT = function (category, input) {
    if (category == undefined) {
        // category auto-detection
        return I18N.DATAPOINT_BY_CATEGORIES(['*'], input);
    }

    var categoryTranslations = I18N.dataPoints[category] || {};
    return categoryTranslations[input] || input;
};

I18N.DATAPOINT_BY_CATEGORIES = function (categories, input) {
    if (categories.length == 1 && categories[0] == '*') {
        categories = _.keys(I18N.dataPoints);
    }

    for (var i = 0; i < categories.length; i++) {
        var translation = I18N.DATAPOINT(categories[i], input);
        if (translation != input) {
            // assumption: if a datapoint name is used in multiple categories
            // the translation is the same -> use the first translation
            return translation;
        }
    }

    // no specific translation found
    return input;
};

I18N.DATAPOINT_BY_ID = function (id, input) {
    var AppState = require('app_state');
    return I18N.DATAPOINT(AppState.getDeviceInfo(id).category, input);
};

I18N.setTranslations = function (language, strings, dataPoints) {
    I18N.language = language;

    I18N.strings = strings;
    I18N.dataPoints = dataPoints;

    Cookie.set('language', language, 365);
};

var initializeSupportedLanguages = function () {
    var defer = $.Deferred();

    if (I18N.supportedLanguages === undefined) {
        Requests.firstURLfromList(
            Requests.getLanguagesURLs(),
            function (languages) {
                I18N.supportedLanguages = languages;
                defer.resolve(I18N.supportedLanguages);
            },
            function () {
                Log.error('Could not initialize supported languages - use defaults');
                I18N.supportedLanguages = { de: 'Deutsch', en: 'English' };
                defer.resolve(I18N.supportedLanguages);
            }
        );
    } else {
        defer.resolve(I18N.supportedLanguages);
    }

    return defer.promise();
};

I18N.setLanguage = function (language) {
    var defer = $.Deferred();
    var self = this;

    $.when(initializeSupportedLanguages()).done(function (supportedLanguages) {
        // initialize language code, use 'en' for unknown languages
        var langCode = language.toLowerCase();
        if (!(langCode in supportedLanguages)) {
            langCode = 'en';
        }

        // language _not_ already loaded? -> load
        if (I18N.language !== langCode) {
            Log.info('I18N::setLanguage ' + langCode);

            var reject = function () {
                Log.error('Could not load translations for ' + langCode);
                defer.reject();
            };

            Requests.firstURLfromList(
                Requests.getLocalizationURLs(langCode, '%.json'),
                function (translation) {
                    Requests.firstURLfromList(
                        Requests.getLocalizationURLs(langCode, '%_datapoints.json'),
                        function (dataPoints) {
                            self.setTranslations(
                                langCode,
                                translation.translations || JSON.parse(translation).translations,
                                dataPoints.translations || JSON.parse(dataPoints).translations
                            );
                            defer.resolve();
                        },
                        reject
                    );
                },
                reject
            );
        } else {
            defer.reject();
        }
    });

    return defer.promise();
};

I18N.languagesList = function () {
    var languages = this.supportedLanguages;

    var languageList = [];
    Object.keys(languages)
        .sort()
        .forEach(function (key) {
            languageList.push({ key: key, value: languages[key] });
        });

    return languageList;
};

// generic click-handler for language selection
I18N.languageClicked = function (e, cb) {
    e.preventDefault();
    var languageChanged = this.setLanguage(e.currentTarget.id);
    $.when(languageChanged).done(function () {
        if (cb) {
            cb();
        } else {
            Backbone.history.loadUrl(Backbone.history.fragment);
        }
    });
};

module.exports = I18N;
